export default __webpack_public_path__ + "media/images/reticle-2fc331737e1da6319855c434947b9116.png";